import React from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { adminKYCApi, superAdminApi } from '@/api';
import { DeepCheckView } from '@/modules/DeepCheckModule/View';
import { usePopups } from '@/hooks';

export const DeepCheckModule = ({ investorId, viewMode }) => {
  const { showInfoToast, showErrorToast } = usePopups();
  const { data: deepCheckRes, refetch } = useQuery({
    queryKey: ['adminKYCApi.getInvestorDeepCheck', investorId],
    queryFn: () => adminKYCApi.getInvestorDeepCheck(investorId)
  });
  const { mutateAsync: mutateInitCheck } = useMutation({
    mutationFn: adminKYCApi.initInvestorDeepCheck
  });
  const { mutateAsync: mutateUploadReport } = useMutation({
    mutationFn: superAdminApi.uploadDeepCheckReport
  });

  const initCheck = async (type) => {
    try {
      await mutateInitCheck({ investorId, type });
      showInfoToast('Sent');
      await refetch();
    } catch (e) {
      console.error(e);
      showErrorToast(e, true);
    }
  };

  const uploadReport = async ({ checkId, file }) => {
    try {
      await mutateUploadReport({ checkId, file });
      showInfoToast('Upload');
      await refetch();
    } catch (e) {
      console.error(e);
      showErrorToast(e, true);
    }
  };

  return (
    <DeepCheckView
      viewMode={viewMode}
      deepCheckData={deepCheckRes?.data}
      initCheck={initCheck}
      uploadReport={uploadReport}
    />
  );
};
